import { render, staticRenderFns } from "./m-addShortAnswer.vue?vue&type=template&id=959191be&"
import script from "./m-addShortAnswer.vue?vue&type=script&lang=js&"
export * from "./m-addShortAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports